import { gql } from "graphql-request";

// Query to get all duty columns with pagination and filtering (without rules)
export const GET_DUTY_COLUMNS = gql`
  query GetDutyColumns($filter: DutyColumnFilterInput) {
    dutyColumns(filter: $filter) {
      data {
        _id
        name
        description
        citations { url postDate }
        isActive
        displayOrder
        columnPriority
        isStackable
        mutuallyExclusiveGroup
        createdAt
        updatedAt
      }
      meta {
        countDocs
        pageNo
        pageSize
      }
    }
  }
`;

// Query to get a single duty column by ID with paginated rules
export const GET_DUTY_COLUMN = gql`
  query GetDutyColumn($id: ID!, $rulesPageNo: Int, $rulesPageSize: Int) {
    dutyColumn(id: $id) {
      data {
        _id
        name
        description
        citations { url postDate }
        isActive
        displayOrder
        columnPriority
        isStackable
        mutuallyExclusiveGroup
        rules(pageNo: $rulesPageNo, pageSize: $rulesPageSize) {
          data {
            _id
            priority
            countries
            countryExclusions
            htsCodes
            exclusions
            rate
            startDate
            endDate
            authority
            rateType
            valueBasis
            isMetal
            exclusiveGroup
            exclusiveMode
            allowedStacksWith
            nonMetalAllowedStacksWith
            requiredWith
            ceilingPercent
            ceilingAgainstAuthority
          }
          meta {
            countDocs
            pageNo
            pageSize
          }
        }
        createdAt
        updatedAt
      }
    }
  }
`;

// Mutation to create a new duty column
export const CREATE_DUTY_COLUMN = gql`
  mutation CreateDutyColumn($dutyColumn: DutyColumnInput!) {
    createDutyColumn(dutyColumn: $dutyColumn) {
      data {
        _id
        name
        description
        citations { url postDate }
        isActive
        displayOrder
        columnPriority
        isStackable
        mutuallyExclusiveGroup
        createdAt
        updatedAt
      }
    }
  }
`;

// Mutation to update an existing duty column
export const UPDATE_DUTY_COLUMN = gql`
  mutation UpdateDutyColumn($id: ID!, $dutyColumn: DutyColumnUpdateInput!) {
    updateDutyColumn(id: $id, dutyColumn: $dutyColumn) {
      data {
        _id
        name
        description
        isActive
        displayOrder
        columnPriority
        isStackable
        mutuallyExclusiveGroup
        createdAt
        updatedAt
      }
    }
  }
`;

// Mutation to delete a duty column
export const DELETE_DUTY_COLUMN = gql`
  mutation DeleteDutyColumn($id: ID!) {
    deleteDutyColumn(id: $id)
  }
`;

// Mutation to add a rule to an existing duty column
export const ADD_RULE_TO_DUTY_COLUMN = gql`
  mutation AddRuleToDutyColumn($columnId: ID!, $rule: DutyRuleInput!) {
    addRuleToDutyColumn(columnId: $columnId, rule: $rule) {
      data {
        _id
        rules(pageNo: 1, pageSize: 5) {
          data {
            _id
            priority
            countries
            countryExclusions
            htsCodes
            exclusions
            rate
            startDate
            endDate
            authority
            rateType
            valueBasis
            isMetal
            exclusiveGroup
            exclusiveMode
            allowedStacksWith
            nonMetalAllowedStacksWith
            requiredWith
            ceilingPercent
            ceilingAgainstAuthority
          }
          meta {
            countDocs
            pageNo
            pageSize
          }
        }
      }
    }
  }
`;

// Mutation to update a rule in a duty column
export const UPDATE_RULE_IN_DUTY_COLUMN = gql`
  mutation UpdateRuleInDutyColumn($columnId: ID!, $ruleId: ID!, $rule: DutyRuleUpdate!) {
    updateRuleInDutyColumn(columnId: $columnId, ruleId: $ruleId, rule: $rule) {
      data {
        _id
        rules(pageNo: 1, pageSize: 5) {
          data {
            _id
            priority
            countries
            countryExclusions
            htsCodes
            exclusions
            rate
            startDate
            endDate
            authority
            rateType
            valueBasis
            isMetal
            exclusiveGroup
            exclusiveMode
            allowedStacksWith
            nonMetalAllowedStacksWith
            requiredWith
            ceilingPercent
            ceilingAgainstAuthority
          }
          meta {
            countDocs
            pageNo
            pageSize
          }
        }
      }
    }
  }
`;

// Mutation to remove a rule from a duty column
export const REMOVE_RULE_FROM_DUTY_COLUMN = gql`
  mutation RemoveRuleFromDutyColumn($columnId: ID!, $ruleId: ID!) {
    removeRuleFromDutyColumn(columnId: $columnId, ruleId: $ruleId) {
      data {
        _id
        rules(pageNo: 1, pageSize: 5) {
          data {
            _id
            priority
            countries
            countryExclusions
            htsCodes
            exclusions
            rate
            startDate
            endDate
            authority
            rateType
            valueBasis
            isMetal
            exclusiveGroup
            exclusiveMode
            allowedStacksWith
            nonMetalAllowedStacksWith
            requiredWith
          }
          meta {
            countDocs
            pageNo
            pageSize
          }
        }
      }
    }
  }
`;

// Optimized query to get only essential duty column data for ordering
export const GET_DUTY_COLUMNS_FOR_ORDERING = gql`
  query GetDutyColumnsForOrdering($filter: DutyColumnFilterInput) {
    dutyColumns(filter: $filter) {
      data {
        _id
        name
        displayOrder
        columnPriority
        isActive
        isStackable
        mutuallyExclusiveGroup
      }
    }
  }
`;

// Query to get authority timeline data
export const GET_AUTHORITY_TIMELINE = gql`
  query GetAuthorityTimeline {
    getAuthorityTimeline {
      authority
      periods {
        startDate
        endDate
        activeColumns {
          name
          priority
          effectiveRate
          ruleId
          ruleNumber
        }
      }
    }
  }
`; 